<!-- BLOCK CONTAINER-->
<div class="wrapper">
  <router-outlet></router-outlet>
</div>

<!-- Loader Modal -->
<div id="loader" class="position-fixed w-100 h-100 text-center d-none" style="top: 0; bottom: 0; left: 0; right: 0; z-index: 1000000; background-color: rgba(0, 0, 0, 0.6)">
  <img class="icon-loader" style="margin-top: 20%" src="assets/pictures/loading2.gif">
</div>

